import { Alert, Center, Loader, Stack, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import type { ReactNode } from "react";

/** Centered loader with an optional message. */
export function LoadingState({ message, h = 240 }: { message?: string; h?: number }) {
  return (
    <Center h={h}>
      <Stack align="center" gap="xs">
        <Loader />
        {message && (
          <Text size="sm" c="dimmed">
            {message}
          </Text>
        )}
      </Stack>
    </Center>
  );
}

/** Inline error banner. */
export function ErrorState({ message, title = "Error" }: { message: ReactNode; title?: string }) {
  return (
    <Alert color="red" variant="light" title={title} icon={<IconAlertTriangle size={16} />}>
      {message}
    </Alert>
  );
}

/** Centered "nothing here yet" placeholder. */
export function EmptyState({ message, h = 200 }: { message: string; h?: number }) {
  return (
    <Center h={h}>
      <Text c="dimmed">{message}</Text>
    </Center>
  );
}
